/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Heading, withLDConsumer, Text, Checkbox } from 'sarsaparilla';
import { CAMPING_TYPES } from 'ui-search/src/constants/filters/camping';
import { toggleFilterGroups } from 'ui-search/src/utils/filters';
import get from 'lodash/get';
import * as tripPlannerActions from '../actions/tripPlanner';

const propTypes = {
    destination: PropTypes.object,
    tripPlanner: PropTypes.object,
    tripPlannerAggregations: PropTypes.object,
    dispatch: PropTypes.func,
};

const defaultProps = {};

export class TripFiltersForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFilters: [],
        };
        this.onFilterToggle = this.onFilterToggle.bind(this);
    }

    onFilterToggle(filterName, item) {
        this.props.dispatch(tripPlannerActions.toggleSearchFilter(filterName, item));
    }

    onFilterSelect = (event, item) => {
        event.preventDefault();
        const params = toggleFilterGroups(item, this.props.tripPlanner);
        this.setState({
            selectedFilters: params,
        });
        setTimeout(() => {
            this.props.dispatch(
                tripPlannerActions.updateTripPlannerCriteria('fg', params)
            );
        }, 0);
    };

    render() {
        return (
            <div className="trip-planner-filters-outer-wrap px-3">
                <div className="my-3">
                    <Heading appearance="h5" headingLevel={2}>
                        Accommodations
                    </Heading>
                    <Text className="py-2">
                        If you&apos;re planning on camping with a specific type of
                        equipment or just want to see day use facilities, use these
                        selections to pre-filter the facilities you&apos;ll be able to add
                        to your trip
                    </Text>
                    {CAMPING_TYPES.map((item) => {
                        const fg = get(this.state, 'selectedFilters', []);
                        const isChecked = fg.indexOf(item.key) !== -1;
                        return (
                            <Checkbox
                                key={item.key}
                                onChange={(e) => this.onFilterSelect(e, item)}
                                id={item.key}
                                label={item.value}
                                value={item.key}
                                isChecked={isChecked}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

TripFiltersForm.propTypes = propTypes;
TripFiltersForm.defaultProps = defaultProps;

function select(state) {
    return {
        tripPlanner: state.tripPlanner,
        tripPlannerAggregations: state.tripPlannerAggregations,
    };
}

export default connect(select)(withLDConsumer()(TripFiltersForm));
